module.exports = __webpack_public_path__ + "media/images/area/popular/harajuku-omotesando-aoyama-d9abd66d6c2560c7bebf0ccfc4f12ff8.jpg";